module.exports = __webpack_public_path__ + "img/advisors.aba52fb5.jpg";